import {
  createWebHistory as create_history,
  createRouter as create
} from 'vue-router'
import routes from '@/routes'
import { me, auth_initialized } from '@/stores/user'

const router = create({
  history: create_history(),
  routes
})

router.beforeEach(async guard => {
  // Wait for auth to be initialized before proceeding
  await auth_initialized

  if (guard.meta.public) return true
  if (!me.value) return { path: '/sign-on' }
  return true
})

export default router
